// service/crm/hooks/useCreateContactImportMutation.ts

import { useMutation } from "@tanstack/react-query";
import { contactImportApi } from "service/crm/api/contactImport";
import {
  ContactImportCreateRequest,
  ContactImportRecord,
} from "types/crm/contactImport";

/**
 * Opens the import for a file that is already on S3.
 *
 * Nothing is cached or invalidated: the import is read back through the steps
 * that follow, not through a contacts list.
 */
export const useCreateContactImportMutation = () =>
  useMutation<ContactImportRecord, unknown, ContactImportCreateRequest>({
    mutationFn: contactImportApi.createImport,
  });
